import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { id: "account" }, [
  /*#__PURE__*/_createElementVNode("path", {
    id: ".fill",
    d: "M12 2C6.47581 2 2 6.47581 2 12C2 17.5242 6.47581 22 12 22C17.5242 22 22 17.5242 22 12C22 6.47581 17.5242 2 12 2ZM12 5.87097C13.9597 5.87097 15.5484 7.45968 15.5484 9.41935C15.5484 11.379 13.9597 12.9677 12 12.9677C10.0403 12.9677 8.45161 11.379 8.45161 9.41935C8.45161 7.45968 10.0403 5.87097 12 5.87097ZM12 19.7419C9.63306 19.7419 7.5121 18.6694 6.09274 16.9919C6.85081 15.5645 8.33468 14.5806 10.0645 14.5806C10.1613 14.5806 10.2581 14.5968 10.3508 14.625C10.875 14.7944 11.4234 14.9032 12 14.9032C12.5766 14.9032 13.129 14.7944 13.6492 14.625C13.7419 14.5968 13.8387 14.5806 13.9355 14.5806C15.6653 14.5806 17.1492 15.5645 17.9073 16.9919C16.4879 18.6694 14.3669 19.7419 12 19.7419Z"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }